<template>
	<v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<show
				:id="id"
				:model-def="modelDef"
				:model-class="modelClass"
				:activities="true"
				:maillogs="false"
				:fileuploader="true">
				<template slot="relations">
					<belongstomany-show
						class="pb-4"
						:headers="headers"
						title="PEC inviate"
						refreshable
						:subFilters="{'valid': true}"
						paginate
						:url="'peccampaignrecipients-filters/' + id">
					</belongstomany-show>
				</template>
			</show>
		</v-col>
	</v-row>
</template>

<script>
	import BelongstomanyShow from '@/components/common/BelongstomanyShow'

	export default {
		name: 'peccampaign',
		components: {
			BelongstomanyShow,
		},

		props: {
			id: Number,
		},

		data() {
			return {
				modelDef: 'peccampaigns',
				modelClass: 'peccampaign',
				headers: [
					{
						'text': '#',
						'sortable': false,
						'value': 'number',
						'width': '40'
					},
					{
						'text': 'Azienda',
						'sortable': false,
						'value': 'company',
					},
					{
						'text': 'PEC',
						'sortable': false,
						'value': 'email',
					},
					{
						'text': 'Stato',
						'sortable': false,
						'value': 'status',
					},
					{
						'text': 'Accettata',
						'sortable': false,
						'value': 'pec_accepted_at',
						'type': 'date',
					},
					{
						'text': 'Consegnata',
						'sortable': false,
						'value': 'pec_delivered_at',
						'type': 'date',
					},
					{
						'text': 'Errore',
						'sortable': false,
						'value': 'pec_error_type',
					}
				]
			}
		},

		created() {
			this.$store.commit('endProgress')
		}
	}
</script>
